import * as CodeMirror from "codemirror";
import {Dimensions, Point, Rectangle} from "./geometry";

export interface ShowTextEditorData {
  id: number | null;
  value: string;
  isText: boolean;
  bounds: Rectangle;
  canvasOriginPx: Point;
  letterSizePx: Dimensions;
  scrollPositionPx: Point;
  textEditorNode: HTMLElement;
}

function textDimensions(text: string): Dimensions {
  const lines = text.split("\n");
  const maxWidth = Math.max.apply(null, lines.map((l) => l.length));
  return {width: maxWidth, height: lines.length};
}

function buildEditorNode(isText: boolean): HTMLElement {
  let textEditorNode = document.querySelector("#text-editor") as HTMLElement;
  if (textEditorNode != null && textEditorNode.parentNode != null) {
    try {
      textEditorNode.parentNode.removeChild(textEditorNode);
    } catch (_) {
      // do nothing
    }
  }
  textEditorNode = document.createElement("div");
  textEditorNode.setAttribute("id", "text-editor");
  textEditorNode.classList.add("is-visible");
  if (!isText) {
    textEditorNode.classList.add("is-shape");
  }

  textEditorNode.addEventListener("keydown", (e) => e.stopPropagation());
  return textEditorNode;
}

function repositionEditor(
    textEditorNode: HTMLElement,
    value: string,
    bounds: Rectangle,
    letterSizePx: Dimensions,
    canvasOriginPx: Point,
    scrollPositionPx: Point,
    isText: boolean
): void {
  let x;
  let y;
  if (isText) {
    x = bounds.start.x * letterSizePx.width + canvasOriginPx.x - scrollPositionPx.x;
    y = bounds.start.y * letterSizePx.height + canvasOriginPx.y - scrollPositionPx.y;
  } else {
    const textDim = textDimensions(value);
    const boundsWidth = Math.abs(bounds.end.x - bounds.start.x) + 1;
    const boundsHeight = Math.abs(bounds.end.y - bounds.start.y) + 1;
    x =
      ((Math.floor(boundsWidth / 2) - Math.floor(textDim.width / 2)) + Math.min(bounds.start.x, bounds.end.x))
      * letterSizePx.width
      + canvasOriginPx.x
      - scrollPositionPx.x;
    y =
      ((Math.floor(boundsHeight / 2) - Math.floor(textDim.height / 2)) + Math.min(bounds.start.y, bounds.end.y))
      * letterSizePx.height
      + canvasOriginPx.y
      - scrollPositionPx.y;
  }
  textEditorNode.style.left = x + "px";
  textEditorNode.style.top = y + "px";
}

export function showTextEditor(payload: ShowTextEditorData, onDone: (newValue: string) => void): void {
  const value = payload.value;
  const isText = payload.isText;
  const bounds = payload.bounds;
  const canvasOriginPx = payload.canvasOriginPx;
  const letterSizePx = payload.letterSizePx;
  const scrollPositionPx = payload.scrollPositionPx;
  const textEditorNode = buildEditorNode(isText);
  repositionEditor(textEditorNode, value, bounds, letterSizePx, canvasOriginPx, scrollPositionPx, isText);
  const content = document.querySelector("#content");
  if (content != null) {
    content.appendChild(textEditorNode);
    const cm = CodeMirror(textEditorNode, {
      lineWrapping: true,
      mode: "text/plain",
      value: value,
      smartIndent: false,
      electricChars: false
    });
    cm.on("change", () => {
      const text = cm.getValue();
      repositionEditor(textEditorNode, text, bounds, letterSizePx, canvasOriginPx, scrollPositionPx, isText);
    });
    cm.on("blur", () => {
      const newValue = cm.getValue();
      if (textEditorNode.parentNode != null) {
        textEditorNode.parentNode.removeChild(textEditorNode);
      }
      onDone(newValue);
    });
    (cm as any).on("keyHandled", (_, __, event: KeyboardEvent) => {
      if (event.keyCode === 27) {
        cm.getInputField().blur();
      }
    });
    cm.focus();
    (cm as any).execCommand("goDocEnd");
  }
}



// WEBPACK FOOTER //
// ./assets/js/text_editor.ts


// WEBPACK FOOTER //
// ./assets/js/text_editor.ts